import React, {useState, useMemo} from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { BtnComponent } from '../../components/button';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { toast } from 'react-toastify';
import { useGroupChatContext } from '../../context/groupchatContext';
import { chngePassword } from '../../services/login';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Input } from '../../components/reactHookFormFields/input';



const ChangePassword = ({closeChangePasswordPopup}) => {

    const { control, formState: { errors }, handleSubmit, } = useForm();
    const currentPassword = useWatch({control, name: 'current_password'});
    const groupChatContext = useGroupChatContext();
    const {authData} = useMemo(() => ({
        authData: groupChatContext.authData,
    }));
    const [isLoading, setIsLoading] = useState(false);
    const [inputVisibility, setInputVisibility] = useState(false);
    const [inputVisibilityConfirmPassword, setInputVisibilityConfirmPassword] = useState(false);
    const [inputVisibilityCurrentPassword, setInputVisibilityCurrentPassword] = useState(false);



    
    const onSubmitForm = async(data, e) => {
        e.preventDefault();

        if(data.new_password == data.confirm_password){
            let token = '&na_auth='+ authData.auth;
            const postData = {
                password: data.new_password,
                current_password: data.current_password
                
            }
            setIsLoading(true);
            chngePassword(postData, token).then((res,) => {

                if(res?.data?.response.code == 0){
                    toast.success(res?.data?.response?.msg);
                    closeChangePasswordPopup();
                }
                else {
                    toast.error(res?.data?.response?.msg);
                }
                }).catch((error) => {
                    toast.error("An error occurred.");
                    console.error(error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }else{
            toast.error("New password and confirm password must be same.")
        }
    }

    const eyeIconClass = "cursor-pointer absolute top-7 right-3 text-gray-500 hover:text-gray-700 transition-colors p-1";

    return (
        <>
            <PageDialogContent
                contentCls="pt-4 pb-2 px-4 sm:px-6 overflow-y-auto"
                hideOverFlow={true}
                contentScroll={false}
            >
                <form id="save_change_password_form" onSubmit={handleSubmit(onSubmitForm)} className="max-w-xl">
                    <p className="text-sm text-gray-500 mb-4">
                        Use at least 8 characters with one uppercase letter, one lowercase letter, and one number.
                    </p>

                    {/* Current Password - full width */}
                    <div className="w-full text-gray-600 mb-4 sm:mb-5">
                        <div className="relative">
                            <Input
                                title="Current Password"
                                name="current_password"
                                type={inputVisibilityCurrentPassword ? "text" : "password"}
                                control={control}
                                rules={{ required: { value: true, message: "Current password is required" } }}
                                errors={errors}
                            />
                            <button
                                type="button"
                                tabIndex={-1}
                                aria-label={inputVisibilityCurrentPassword ? "Hide password" : "Show password"}
                                className={eyeIconClass}
                                onClick={() => setInputVisibilityCurrentPassword(!inputVisibilityCurrentPassword)}
                            >
                                {!inputVisibilityCurrentPassword ? <FaEye size={18} /> : <FaEyeSlash size={18} />}
                            </button>
                        </div>
                    </div>

                    {/* New + Confirm - stack on mobile, side-by-side on sm+ */}
                    <div className="w-full flex flex-col sm:flex-row sm:gap-4 gap-4 sm:gap-5 mb-4 sm:mb-5">
                        <div className="flex-1 min-w-0 relative">
                            <Input
                                title="New Password"
                                name="new_password"
                                type={inputVisibility ? "text" : "password"}
                                control={control}
                                rules={{
                                    required: { value: true, message: "Password is required" },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                        message: "At least 8 characters with uppercase, lowercase, and number",
                                    },
                                    validate: (value) => {
                                        if (value === currentPassword) {
                                            return "New password must be different from current password";
                                        }
                                        return true;
                                    },
                                }}
                                errors={errors}
                            />
                            <button
                                type="button"
                                tabIndex={-1}
                                aria-label={inputVisibility ? "Hide password" : "Show password"}
                                className={eyeIconClass}
                                onClick={() => setInputVisibility(!inputVisibility)}
                            >
                                {!inputVisibility ? <FaEye size={18} /> : <FaEyeSlash size={18} />}
                            </button>
                        </div>
                        <div className="flex-1 min-w-0 relative">
                            <Input
                                title="Confirm Password"
                                name="confirm_password"
                                type={inputVisibilityConfirmPassword ? "text" : "password"}
                                control={control}
                                rules={{
                                    required: { value: true, message: "Password is required" },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                        message: "At least 8 characters with uppercase, lowercase, and number",
                                    },
                                }}
                                errors={errors}
                            />
                            <button
                                type="button"
                                tabIndex={-1}
                                aria-label={inputVisibilityConfirmPassword ? "Hide password" : "Show password"}
                                className={eyeIconClass}
                                onClick={() => setInputVisibilityConfirmPassword(!inputVisibilityConfirmPassword)}
                            >
                                {!inputVisibilityConfirmPassword ? <FaEye size={18} /> : <FaEyeSlash size={18} />}
                            </button>
                        </div>
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
                    <BtnComponent text="Close" btnType="default" onClick={closeChangePasswordPopup} />
                    <BtnComponent text="Save" btnType="primary_theme" loading={isLoading} form="save_change_password_form" type="submit" />
                </div>
            </PageDialogFooter>
        </>
    );
};

export default ChangePassword;
